document.addEventListener("DOMContentLoaded", () => {
  // Run ONLY on homepage (Dawn uses data-template="index" on main)
  const main = document.querySelector('main#MainContent[data-template="index"]');
  if (!main) return;

  const bgSection = document.querySelector(".rz-home-bg");
  if (!bgSection) return;

  const media = bgSection.querySelector(".rz-home-bg__media");
  if (!media) return;

  // Choose URL
  const desktopUrl = media.getAttribute("data-video-desktop") || "";
  const mobileUrl = media.getAttribute("data-video-mobile") || "";
  const isMobile = window.matchMedia("(max-width: 989px)").matches;
  const chosenUrl = (isMobile && mobileUrl) ? mobileUrl : desktopUrl;

  const vid = media.querySelector("video");

  // If we have a chosen URL, ensure the correct source is set (mobile swaps)
  if (vid && chosenUrl) {
    const currentSource = vid.querySelector("source");
    const currentSrc = currentSource?.getAttribute("src") || "";

    if (!currentSource || currentSrc !== chosenUrl) {
      while (vid.firstChild) vid.removeChild(vid.firstChild);

      const source = document.createElement("source");
      source.src = chosenUrl;
      source.type = "video/mp4";
      vid.appendChild(source);

      vid.load();
    }
  }

  // Create portal at end of body
  let portal = document.getElementById("rz-home-bg-portal");
  if (!portal) {
    portal = document.createElement("div");
    portal.id = "rz-home-bg-portal";
    document.body.appendChild(portal);
  }

  // Move media into portal
  portal.appendChild(media);

  // Zero-height placeholder
  bgSection.style.cssText =
    "height:0!important;min-height:0!important;margin:0!important;padding:0!important;overflow:visible!important;";

  // Full viewport, BEHIND everything
  portal.style.cssText = `
    position:fixed !important;
    top:0 !important; left:0 !important; right:0 !important; bottom:0 !important;
    width:100vw !important; height:100vh !important;
    max-width:none !important;
    overflow:hidden !important;
    pointer-events:none !important;
    z-index:-1 !important;
  `;

  // Fill portal
  media.style.cssText = `
    position:absolute !important;
    inset:0 !important;
    width:100% !important; height:100% !important;
    max-width:none !important;
  `;

  // Video styling + tint
  if (vid) {
    vid.style.cssText = `
      position:absolute !important;
      inset:0 !important;
      width:100% !important; height:100% !important;
      max-width:none !important;
      object-fit:cover !important;
      z-index:0 !important;

      opacity: 0.35 !important;
      filter: brightness(0.85) contrast(1.05) saturate(0.9) !important;
    `;

    vid.play().catch(() => {});
  }

  // Overlay unused (kept harmless)
  const overlay = media.querySelector(".rz-home-bg__overlay");
  if (overlay) {
    overlay.style.cssText = `
      position:absolute !important;
      inset:0 !important;
      z-index:10 !important;
      display:none !important;
    `;
  }

  // Ensure homepage content above
  main.style.position = "relative";
  main.style.zIndex = "20";
});